import {fetchArticles} from "../components/news/_article.fetch.js";

export const initLoadMore = () => {
  const MORE_BUTTON = document.querySelector('[data-load-more="button"]');
  if (!MORE_BUTTON) return

  MORE_BUTTON.addEventListener('click', () => {
    return fetchArticles(true)
  })
}
